import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import * as api from '@services/api'

export const fetchStores = createAsyncThunk(
  'storeRecommendation/fetchStores',
  async (params: any) => {
    const response = await api.fetchRecommendStoreList(params)
    return response
  }
)

export const fetchRecommendations = createAsyncThunk(
  'storeRecommendation/fetchRecommendations',
  async (params: any) => {
    const response = await api.fetchStoreRecommendationList(params)
    return response
  }
)

export const download = createAsyncThunk(
  'storeRecommendation/download',
  async (params: any) => {
    const response = await api.downloadStoreRecommendation(params)
    return response
  }
)

const initialState = {
  recommendationList: [],
  storeList: [],
  selectedStore: {} as any,
  storeFilter: {
    pageIndex: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
    keyword: '',
    status: '-1'
  },
  recommendationFilter: {
    pageIndex: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0
  },
  isDownloading: false
}

const storeRecommendationSlice = createSlice({
  name: 'storeRecommendation',
  initialState,
  reducers: {
    selectStore: (state, action) => {
      state.selectedStore = action.payload
    },
    setKeyword: (state, action) => {
      state.storeFilter.keyword = action.payload
    },
    setStatus: (state, action) => {
      state.storeFilter.status = action.payload
    },
    setDownload: (state, action) => {
      state.isDownloading = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchStores.fulfilled, (state, action) => {
      state.storeList = action.payload.data
      state.storeFilter.pageIndex = action.payload.pageIndex
      state.storeFilter.pageSize = action.payload.pageSize
      state.storeFilter.totalPage = action.payload.totalPage
      state.storeFilter.totalRecords = action.payload.totalRecords
    })
    builder.addCase(fetchRecommendations.fulfilled, (state, action) => {
      state.recommendationList = action.payload.data
      state.recommendationFilter.pageIndex = action.payload.pageIndex
      state.recommendationFilter.pageSize = action.payload.pageSize
      state.recommendationFilter.totalPage = action.payload.totalPage
      state.recommendationFilter.totalRecords = action.payload.totalRecords
    })
  }
})

export const {
  selectStore,
  setKeyword,
  setStatus,
  setDownload
} = storeRecommendationSlice.actions

export default storeRecommendationSlice.reducer
